module.exports = __webpack_public_path__ + "static/media/jest.1d91c572.png";